import React, { useEffect, useRef, useState } from 'react';
import DateRangePicker from '../DateRangePicker/DateRangePicker';

/**
 * 트랙 9-0e — DateRangeSearchBar
 * 기간 선택 (DateRangePicker split) + 검색 버튼이 묶인 search bar.
 * - 마운트 시 자동 검색 옵션 (`autoSearchOnMount`, default true)
 * - 기본 기간: 오늘 - `defaultDays` (default 30) ~ 오늘
 * - 기간 변경만으로는 onSearch 호출 X (검색 버튼 명시 클릭만)
 * - 운영 `Search.jsx` / `DateRangePicker.jsx` 무손상
 */
const isoDate = (d) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${dd}`;
};

const computeDefaultRange = (days) => {
  const today = new Date();
  const start = new Date();
  start.setDate(today.getDate() - days);
  return { startDt: isoDate(start), endDt: isoDate(today) };
};

const DateRangeSearchBar = ({
  onSearch,
  defaultDays = 30,
  loading = false,
  autoSearchOnMount = true,
  label = '검색',
}) => {
  const [period, setPeriod] = useState(() => computeDefaultRange(defaultDays));
  const didAutoSearch = useRef(false);

  const handleSearch = () => {
    if (typeof onSearch !== 'function') return;
    onSearch({ start: period.startDt, end: period.endDt });
  };

  useEffect(() => {
    if (didAutoSearch.current) return;
    if (!autoSearchOnMount) return;
    didAutoSearch.current = true;
    if (typeof onSearch === 'function') {
      onSearch({ start: period.startDt, end: period.endDt });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="date-range-search-bar"
      style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}
    >
      <DateRangePicker
        startKey="startDt"
        endKey="endDt"
        formData={period}
        setFormData={setPeriod}
        split
      />
      <button
        type="button"
        className="date-range-search-bar-btn"
        onClick={handleSearch}
        disabled={loading}
      >
        {label}
      </button>
    </div>
  );
};

export default DateRangeSearchBar;
